<div class="row"  [formGroup]="subForm" >
    <div class="col-md-6">
        <div class="form-group">
            <label class="form-label">نوع الحساب</label>
            <input class="form-control" type="text" [value]="getRegistrationAsName()" readonly>
        </div>
    </div>
    <div class="col-md-6">
        <div class="form-group">
            <label class="form-label">
                @if (getRegistrationId() === RegisterAsInspector.facility) {
                    اسم المؤسسة
                } @else {
                    الاسم الأول
                }
            </label>
            <input formControlName="first_name" class="form-control" type="text">
            <img class="form-control-feedback" src="assets/images/svg/error-icon1.svg" alt="">
        </div>
    </div>
    <div class="col-md-6">
        <div class="form-group">
            <label class="form-label">
                @if (getRegistrationId() === RegisterAsInspector.facility) {
                    التوصيف
                } @else {
                    الاسم الأخير
                }
            </label>
            <input formControlName="last_name" class="form-control" type="text">
            <img class="form-control-feedback" src="assets/images/svg/error-icon1.svg" alt="">
        </div>
    </div>
    <div class="col-md-6">
        <div class="form-group">
            <label class="form-label">البريد الإلكتروني</label>
            <input formControlName="email" class="form-control" type="text">
            <img class="form-control-feedback" src="assets/images/svg/error-icon1.svg" alt="">
        </div>
    </div>
    <div class="col-md-6">
        <div class="form-group">
            <label class="form-label">رقم الجوال</label>
            <input formControlName="mobile" class="form-control" type="text">
            <img class="form-control-feedback" src="assets/images/svg/error-icon1.svg" alt="">
        </div>
    </div>
    @if (getRegistrationId() === RegisterAsInspector.facility) {
        <div class="col-md-6">
            <div class="form-group">
                <label class="form-label">رقم السجل التجاري</label>
                <input formControlName="commercial_registration_no" class="form-control" type="text">
                <img class="form-control-feedback" src="assets/images/svg/error-icon1.svg" alt="">
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label class="form-label">تاريخ السجل التجاري</label>
                <mat-form-field (click)="commercialRegDatePicker.open()" appearance="outline">
                    <input matInput formControlName="commercial_registration_date"
                        [matDatepicker]="commercialRegDatePicker" [disabled]="false" />
                    <mat-datepicker-toggle matSuffix [for]="commercialRegDatePicker">
                        <mat-icon matDatepickerToggleIcon class="calender-icon">
                            <img src="assets/images/svg/calendar-admin-icon.svg" alt="">
                        </mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #commercialRegDatePicker [disabled]="false"></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label class="form-label">اسم مسؤول التواصل</label>
                <input formControlName="communicator_name" class="form-control" type="text">
                <img class="form-control-feedback" src="assets/images/svg/error-icon1.svg" alt="">
            </div>
        </div>
    }
</div>
